export default __webpack_public_path__ + "static/media/arrow-curved-long.5e0ae3f6.svg";